/** @jsxImportSource @emotion/react */
import React from 'react'
import { css } from '@emotion/react'

import { compose } from 'ramda'
import { createEditor } from 'slate'
import { Editable, Slate, withReact } from 'slate-react'
import { COLORS } from '@btime/constants'

import EditorContext from '../EditorContext'
import { useEditorKeydown } from '../_plugins/keydowns'
import Panel from '../../../kiti/components/structure/Panel'
import { renderElement, renderLeaf } from '../_plugins/plugins'
import { deserializeText, serializeText } from '../_serializers/textSerializer'
import InterpolationPlugin from '../_plugins/InterpolationPlugin'
import Separator from '../../../kiti/components/helpers/Separator'
import { Absolute, Relative } from '../../../kiti/components/helpers/Position'

const NumberInputWithInterpolation = ({ value, onChange, interpolations }) => {
  const styles = css`
    & .panel {
      border-radius: 0.3rem;
      border-color: ${COLORS.light5};
    }
  `

  const [editor] = React.useState(() =>
    compose(InterpolationPlugin.extend({ fullControl: false }), withReact)(createEditor())
  )

  const availableTypes = ['raw_numeric', 'raw_number', 'raw_float', 'raw_calc']
  const onlyNumbersInterpolations = interpolations.filter(interpolation => availableTypes.includes(interpolation?.type))

  editor.singleLine = true
  editor.numbers = true

  const initialValue = deserializeText(value || '', onlyNumbersInterpolations)

  return (
    <div css={styles}>
      <Panel padding={0} radius={0.4}>
        <Slate editor={editor} value={initialValue} onChange={compose(onChange, serializeText)}>
          <EditorContext size="small">
            <Relative zIndex="auto">
              <Separator paddingV={0.6} paddingH={0.7}>
                <Editable onKeyDown={useEditorKeydown(editor)} renderElement={renderElement} renderLeaf={renderLeaf} />

                <Absolute right={0} top={-1.5} zIndex="auto">
                  <InterpolationPlugin.Dropdown options={onlyNumbersInterpolations} />
                </Absolute>
              </Separator>
            </Relative>
          </EditorContext>
        </Slate>
      </Panel>
    </div>
  )
}

export default NumberInputWithInterpolation
